import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkle } from "@phosphor-icons/react";
import { Seo } from "@/components/Seo";
import { PublicNavbar } from "@/components/public/PublicNavbar";
import { PublicFooter } from "@/components/public/PublicFooter";
import { WhatsAppFab } from "@/components/public/WhatsAppFab";
import { BLOG_POSTS } from "@/data/blog";

export default function Blog() {
  const navigate = useNavigate();
  return (
    <div className="bg-background min-h-screen">
      <Seo title="Blog — AI Marka Radar" description="Yapay zekâ aramalarında görünürlük, AEO ve GEO üzerine rehberler ve yazılar." path="/blog" />
      <PublicNavbar />
      <WhatsAppFab />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <p className="font-mono text-xs tracking-[0.2em] uppercase text-brand mb-3">Blog</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">AEO & GEO Rehberi</h1>
        <p className="text-muted-foreground mt-4 max-w-2xl text-lg">Yapay zekâ çağında marka görünürlüğü üzerine pratik, dürüst içerikler.</p>
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {BLOG_POSTS.map((p) => (
            <button key={p.slug} onClick={() => navigate(`/blog/${p.slug}`)} data-testid={`blog-list-${p.slug}`}
              className="border border-border text-left h-full flex flex-col hover:border-brand transition-colors">
              <div className="h-40 bg-brand/5 flex items-center justify-center border-b border-border">
                <Sparkle size={36} weight="bold" className="text-brand/40" />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <span className="font-mono text-xs text-muted-foreground">{p.date} · {p.readingTime}</span>
                <h2 className="font-heading font-semibold text-lg leading-snug mt-2">{p.title}</h2>
                <p className="text-sm text-muted-foreground mt-2 flex-1">{p.excerpt}</p>
                <span className="text-sm text-brand font-medium mt-4 inline-flex items-center gap-1">Devamını Oku <ArrowRight size={14} /></span>
              </div>
            </button>
          ))}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
